import React from 'react'
import { MainHeading, PageHeaderIntro, FindAgent, Breadcrumb, FigureCards, Faq, NewsCard } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './commercial-umbrella-insurance.scss';

const CommercialUmbrellaInsurance = () => {

    const HeaderData = [
        {
            image: images['Icon_blue_two_people_under_umbrella.svg'],
            para: 'You buy standard business liability insurance to cover you in the event of an accident. But what happens if your costs are greater than your liability policy limits? How will you pay the remaining balance? Commercial umbrella liability insurance picks up where your standard liability leaves off. Let us help give you an extra layer of protection with commercial umbrella liability coverage.',
        },
    ];
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "General liability insurance", link: "/what-we-offer/insurance-products/general-liability-insurance" },
        { label: "Commercial umbrella insurance", link: "/what-we-offer/insurance-products/general-liability-insurance/commercial-umbrella-insurance" },
    ];
    const faqData = [
        {
            id: 1,
            eventKey: 1,
            header: 'When would I need commercial umbrella coverage?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'What does commercial umbrella insurance cover?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'Does my company need an umbrella policy?',
            body: 'We help owners like you determine the right insurance policy that balances the best combination of price and protection for your business—from Call us for more information or find a local insurance agent to get started on your personalized quote.'
        }
    ]
    const featuredCard = [
        {
            id: 1,
            value: "5k+",
            unit: "Sentry associates",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 2,
            value: "8",
            unit: "Sentry leaders",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 3,
            value: "1992",
            unit: "First year",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
    ];
    const NewsCardData = [
        {
            id: 1,
            title: 'Getting your employees ready to retire',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'Read more >',
        },
        {
            id: 2,
            title: 'Secure Act 2.0',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'Read more >',
        },
        {
            id: 3,
            title: 'Sentry news',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'Read more >',
        },

    ];
    return (
        <div className='commercial-umbrella-insurance-main'>
            <Container>
                {/* Breadcrum */}
                <Breadcrumb crumbs={breadcrumbs} />

                {/* heading  */}
                <MainHeading title="Commercial umbrella insurance" showshare={false} />

                {/* page intro */}
                <PageHeaderIntro Data={HeaderData} />

                <Faq heading="FAQs" FaqData={faqData} />

                <FigureCards data={featuredCard} heading="Significant figures" />

                {/* news card section */}
                <NewsCard Title="More reasons to choose Sentry" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />

                <FindAgent />
            </Container>
        </div>
    )
}

export default CommercialUmbrellaInsurance;